import type { ReactElement } from 'react';

import { useActiveCompany } from '@/lib/active-company-context';

import { usePageChrome } from './page-chrome-context';

/** Cinta mono de contexto (elemento-firma del sistema). Izquierda fija (sello
 *  del QMS), centro = contexto de la pantalla + empresa, derecha = dato de la
 *  pantalla (lo aporta cada página, nunca un número inventado). */
export function Ribbon(): ReactElement {
  const { navContext, ribbonRight } = usePageChrome();
  const { activeCompanyName } = useActiveCompany();
  const context = [navContext, activeCompanyName].filter(Boolean).join(' · ');

  return (
    <div className="ribbon">
      <span>
        <span className="dot" />
        QMS Digital · ISO 9001:2015 · BPADIS
      </span>
      {context && (
        <>
          <span className="sep">/</span>
          <span>{context}</span>
        </>
      )}
      {ribbonRight && <span className="r">{ribbonRight}</span>}
    </div>
  );
}
